module.exports = __webpack_public_path__ + "static/img/p04.4207580.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/comic/002/p04.jpg
// module id = 134
// module chunks = 0